import styled from 'styled-components';

export const SecondaryModernButton = styled.button`
  font-family: 'Ubuntu', sans-serif;
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  border-radius: 6px;
  padding: 1rem 2rem;
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  font-size: ${({ theme }) => theme.FONT_SIZES.primary};
  font-weight: 700;
  text-transform: uppercase;
  transition: box-shadow 0.42s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: none;
  box-shadow: inset 0 0 0 2px ${({ theme }) => theme.UI_COLORS.primary};
  text-decoration: none;

  svg {
    fill: ${({ theme }) => theme.UI_COLORS.secondary};
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    font-size: ${({ theme }) => theme.FONT_SIZES.secondary};
    padding: 1.4rem 2rem;
  }

  &:hover {
    box-shadow: inset 0 0 0 3px ${({ theme }) => theme.UI_COLORS.primary};
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.UI_COLORS.secondary};
    background-color: ${({ theme }) => theme.UI_COLORS.main_gray};
  }
`;
